import { render, staticRenderFns } from "./IconAlarm.vue?vue&type=template&id=ec184b56&"
import script from "./IconAlarm.vue?vue&type=script&lang=ts&"
export * from "./IconAlarm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports